// Shared helpers for list-page filtering (query-string building + date presets).

/** Build a `?a=b&c=d` query string, skipping empty/undefined/'all' values. */
export function buildQuery(params: Record<string, string | number | undefined | null>): string {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '' || v === 'all') continue;
    usp.set(k, String(v));
  }
  const s = usp.toString();
  return s ? `?${s}` : '';
}

export interface DateRange {
  from?: string; // YYYY-MM-DD
  to?: string;   // YYYY-MM-DD (exclusive end; presets pass the day AFTER the range)
}

const iso = (d: Date) => d.toISOString().slice(0, 10);

/** Named presets. `to` is exclusive (start of the day after the period's last day). */
export function datePreset(key: string): DateRange {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  switch (key) {
    case 'thisYear':
      return { from: `${y}-01-01`, to: `${y + 1}-01-01` };
    case 'thisMonth':
      return { from: iso(new Date(Date.UTC(y, m, 1))), to: iso(new Date(Date.UTC(y, m + 1, 1))) };
    case 'thisQuarter': {
      const q = Math.floor(m / 3) * 3;
      return { from: iso(new Date(Date.UTC(y, q, 1))), to: iso(new Date(Date.UTC(y, q + 3, 1))) };
    }
    case 'last90': {
      const from = new Date(now);
      from.setUTCDate(from.getUTCDate() - 90);
      return { from: iso(from), to: iso(new Date(Date.UTC(y, m, now.getUTCDate() + 1))) };
    }
    case 'lastYear':
      return { from: `${y - 1}-01-01`, to: `${y}-01-01` };
    default:
      return {};
  }
}

export const DATE_PRESETS: { key: string; label: string }[] = [
  { key: 'all', label: 'All time' },
  { key: 'thisYear', label: 'This year' },
  { key: 'thisQuarter', label: 'This quarter' },
  { key: 'thisMonth', label: 'This month' },
  { key: 'last90', label: 'Last 90 days' },
  { key: 'lastYear', label: 'Last year' },
];
